import React,{useEffect} from 'react';
import './styles.css';
import logoSvg from "../../../assets/chanakyaLogo.svg"
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import { ApiCollection } from '../../../config/envConfig';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import paperanalysis from "../../../assets/paperanalysis.png"
import assessmentsPaper from "../../../assets/assesmentsPaper.png"
import { logEvent, logException } from '../../../utils/analytics/analytics';

const Signup: React.FC = () => {
  const navigate = useNavigate();
  const [values, setValues] = React.useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    mobileNo: '',
    stream: '',
    class: '10th',
  });
  const [errors, setErrors] = React.useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    mobileNo: '',
    stream: '',
    class: '',
  });
  const [loading, setLoading] = React.useState(false);
  const [classes, setClasses] = React.useState<string[]>([]);
  const [streams, setStreams] = React.useState<string[]>([]);

  const newErrors = {
    firstName: !values.firstName ? 'First name is required' : '',
    lastName: !values.lastName ? 'Last name is required' : '',
    email: !values.email ? 'Email is required' : 
          !/\S+@\S+\.\S+/.test(values.email) ? 'Invalid email format' : '',
    mobileNo: !values.mobileNo ? 'Mobile number is required' :
             !/^\d{10}$/.test(values.mobileNo) ? 'Invalid mobile number (10 digits required)' : '',
    password: !values.password ? 'Password is required' :
             values.password.length < 8 ? 'Password must be at least 8 characters' : '',
    confirmPassword: !values.confirmPassword ? 'Please confirm your password' :
                    values.password !== values.confirmPassword ? 'Passwords do not match' : '',
    class: !values.class ? 'Class is required' : '',
    stream: streams.length > 0 && !values.stream ? 'Stream is required' : '',
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type, checked } = e.target as HTMLInputElement;
    setValues(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    if (errors[name as keyof typeof errors]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
    
    if (name === 'class') {
      if (value === '12th') {
        fetchStreams(value);
      } else {
        setStreams([]);
        setValues(prev => ({
          ...prev,
          stream: ''
        }));
        setErrors(prev => ({
          ...prev,
          stream: ''
        }));
      }
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    

    setErrors({
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: '',
      mobileNo: '',
      stream: '',
      class: '',
    });

    setErrors(newErrors);

    // Checking if there are any errors
    const hasErrors = Object.values(newErrors).some(error => error !== '');
    
    if (!hasErrors) {
    
      onSignupPress();
    }
  };

  const onSignupPress = async () => {
    try {
      setLoading(true);
      logEvent('User', 'Signup Attempt', `Class ${values.class}${values.stream ? ` - ${values.stream}` : ''}`);
      
      const signupData = {
        organisation: "NeuroBridge",
        email: values.email,
        mobile_number: values.mobileNo,
        first_name: values.firstName,
        last_name: values.lastName,
        password: values.password,
        educational_info: {
          class: values.class,
          stream: values.stream
        }
      };
      const response = await axios.post(ApiCollection.user.signup, signupData);
      if (response.data) {
        logEvent('User', 'Signup Success', `Class ${values.class}${values.stream ? ` - ${values.stream}` : ''}`);
        toast.success(response.data.message);
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      }
    } catch (error: any) {
      const errorMessage = error.response?.data?.detail || "An error occurred during signup";
      logException(`Signup Failed: ${errorMessage}`, false);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const fetchStreams = async (classValue: string) => {
    try {
      const response = await axios.get(`${ApiCollection.user.getStreams}?class=${classValue}`);
      setStreams(response.data.available_stream);
      setValues(prev => ({
        ...prev,
        stream: ''
      }));
    } catch (error) {
      console.error('Error fetching streams:', error);
      logException('Failed to load streams', false);
      toast.error('Failed to load streams');
    }
  };

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const response = await axios.get(ApiCollection.user.getClasses);
        setClasses(response.data.available_classes);
      } catch (error) {
        console.error('Error fetching classes:', error);
        logException('Failed to load classes', false);
      }
    };
    fetchClasses();
  }, []);

  const responsiveSignup = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-content">
        <div className="signup-left">
          <div className="signup-carousel-wrapper">
            <Carousel
              responsive={responsiveSignup}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={4000}
              showDots={true}
              removeArrowOnDeviceType={["tablet", "mobile"]}
              className="signup-carousel-container"
              customTransition="transform 500ms ease-in-out"
              transitionDuration={500}
              containerClass="signup-carousel-container"
              dotListClass="signup-custom-dot-list-style"
              itemClass="signup-carousel-item"
            >

                <div className="signup-carousel-item">
                <img
                  src={assessmentsPaper}
                  alt="Student Overview"
                  className="signup-overview-image"
                />
              </div>
              <div className="signup-carousel-item">
                <img
                  src={paperanalysis}
                  alt="Student Overview"
                  className="signup-overview-image"
                />
              </div>

            </Carousel>
          </div>
          <div className="text-content-container">
            <h1>Welcome to Our Platform</h1>
            <p>Join us to access comprehensive educational resources, assessments, and personalized learning experiences designed to help you succeed in your academic journey.</p>
          </div>
        </div>

        <div className="signup-right">
          <img
            src={logoSvg}
            alt="Logo"
            className="chanakya-logo-signup"
          />
          <form onSubmit={handleSubmit} className="signup-form">
            <div className="form-row">
              <div className="form-group">
                <label>First Name</label>
                <input
                  type="text"
                  name="firstName"
                  placeholder="Enter your first name"
                  value={values.firstName}
                  onChange={handleChange}
                  className={errors.firstName ? 'error-input' : ''}
                />
                {errors.firstName && <span className="error-text">{errors.firstName}</span>}
              </div>
              <div className="form-group">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  placeholder="Enter your last name"
                  value={values.lastName}
                  onChange={handleChange}
                  className={errors.lastName ? 'error-input' : ''}
                />
                {errors.lastName && <span className="error-text">{errors.lastName}</span>}
              </div>
            </div>
            <div className="form-row">
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                placeholder="Enter your email address"
                value={values.email}
                onChange={handleChange}
                className={errors.email ? 'error-input' : ''}
              />
              {errors.email && <span className="error-text">{errors.email}</span>}
            </div>
            <div className="form-group">
              <label>Mobile Number</label>
              <input
                type="tel"
                name="mobileNo"
                placeholder="Enter your mobile number"
                value={values.mobileNo}
                onChange={handleChange}
                className={errors.mobileNo ? 'error-input' : ''}
              />
              {errors.mobileNo && <span className="error-text">{errors.mobileNo}</span>}
            </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Class</label>
                <select
                  name="class"
                  value={values.class}
                  onChange={handleChange}
                  className={`${errors.class ? 'error-input' : ''}`}
                >

                  <option value="">Select Class</option>
                  {classes.map((classOption) => (
                    <option key={classOption} value={classOption}>
                      {classOption}
                    </option>
                  ))}
                </select>
                {errors.class && <span className="error-text">{errors.class}</span>}
              </div>
              <div className="form-group">
                <label>Stream</label>
                <select
                  name="stream"
                  value={values.stream}
                  onChange={handleChange}
                  disabled={values.class === '10th'}
                  className={`${errors.stream ? 'error-input' : ''} ${values.class === '10th' ? 'disabled-select' : ''}`}
                >
                  <option value="">Select Stream</option>
                  {streams.map((stream) => (
                    <option key={stream} value={stream}>
                      {stream}
                    </option>
                  ))}
                </select>
                {errors.stream && <span className="error-text">{errors.stream}</span>}
              </div>
            </div>
            <div className="form-row">
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                name="password"
                placeholder="Create a password"
                value={values.password}
                onChange={handleChange}
                className={errors.password ? 'error-input' : ''}
              />
              {errors.password && <span className="error-text">{errors.password}</span>}
            </div>
            <div className="form-group">
              <label>Confirm Password</label>
              <input
                type="password"
                name="confirmPassword"
                placeholder="Confirm your password"
                value={values.confirmPassword}
                onChange={handleChange}
                className={errors.confirmPassword ? 'error-input' : ''}
              />
              {errors.confirmPassword && <span className="error-text">{errors.confirmPassword}</span>}
            </div>
            </div>
            <div className="form-group terms-text">
              <strong>By agreeing to the Terms and Conditions, I agree to the processing of my personal information.</strong>
            </div>
            <button type="submit" disabled={loading}>
              <div className="button-content">
                {loading && <span className="signup-spinner"></span>}
                {loading ? 'Signing up' : 'Sign Up'}
              </div>
            </button>
            <p className="signin-text">
              Already have an account? <span onClick={() => navigate('/login')} className="signin-link">Sign In</span>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Signup;
